import React from 'react'
import { compose } from "recompose";
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps";


interface IProps {
  latitude: number;
  longitude: number;
  css: React.CSSProperties;
}

const MyMapComponent = compose(
  withScriptjs,
  withGoogleMap
)((props: any) => (
  <GoogleMap
    defaultZoom={19}
    defaultCenter={{ lat: props.latitude, lng: props.longitude }}
    onCenterChanged={() => {

    }}
  >
    {props.isMarkerShown && (
      <Marker
        defaultVisible={true}
        noRedraw={true}
        position={{ lat: props.latitude, lng: props.longitude }}
      />
    )}
  </GoogleMap>
));

const Map = ({ latitude, longitude, css }: IProps) => {

  return (
    <MyMapComponent
      loadingElement={<div style={css} />}
      containerElement={<div style={css} />}
      mapElement={<div style={css} />}
      googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBrOroeRCI2TGoLteUcVUGQRhZxN-bDGGU&v=3.exp&libraries=geometry,drawing,places"
      isMarkerShown
      latitude={latitude}
      longitude={longitude}
    />
  )
}

export default Map